import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

import Button from 'src/components/Button/Button';
import { RootState, select } from 'src/configs/store';
import formatOdds from 'src/utils/formatOdds';

function RegisterBetButton() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { bets, slip, processing, maximumReturn, totalOdds, totalAmount } = useSelector((state: RootState) => state.betslip);
  const totalCombinations = useSelector(select.betslip.totalCombinations);
  const { selectedOddsType } = useSelector((state: RootState) => state.odds);


  const handleRegisterBet = useCallback(async () => {
    dispatch.betslip.registerBet();
  }, []);

  return (
    <Button
      type="submit"
      className="betslip-wrapper__button betslip-wrapper__button--register btn--primary"
      text={ t('betslip.placeBet') }
      disabled={ processing }
      onClick={ handleRegisterBet }
    >
      {
        processing ? (
          <span>{ t('betslip.registerBet') }</span>
        ) : (
          <>
            <span>{ t('betslip.registerBet', { value: processing ? '--.--' : totalAmount?.toFixed(2) }) }</span>
            <span>
              {
                !_.some(bets, (bet) => (_.isNaN(+bet.odds) || !bet.odds)) &&
                t(`betslip.${ slip === 1 && totalCombinations === 1 ? 'potentialReturnWithOdds' : 'potentialReturnBtn' }`, {
                  return: processing  ? '--.--' : maximumReturn?.toFixed(2),
                  odds: processing ? '--.--' : formatOdds(totalOdds, selectedOddsType)
                })
              }
            </span>
          </>
        )
      }
    </Button>
  );
}

export default memo(RegisterBetButton);
